import React, {
    useState,
    useEffect
}
from "react";

import {
    useParams
}
from "react-router-dom";

import {
    functions
}
from "../../../constants/common-functions";

import MobileHeader
from "../../home/mobile/components/MobileHeader";

import ForgeViewer
from "../../../components/ForgeViewer";

import useFolderForager
from "../hooks/useFolderForager";

import "./MobileDocuments.css";


export default function MobileDocuments()
{

    //--------------------------------------------------------
    // Parameters
    //--------------------------------------------------------

    const { id } =
        useParams();


    //--------------------------------------------------------
    // Forager
    //--------------------------------------------------------

    const
    {
        loading,
        directories,
        selectedDirectory,
        documents,
        selectedDocument,
        setSelectedDocument,
        expandDirectory,
        selectDirectory
    }
    =
    useFolderForager();


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [searchText, setSearchText] =
        useState("");

    const [viewerType, setViewerType] =
        useState(null);

    const [openDocumentUrl, setOpenDocumentUrl] =
        useState(null);

    const [openDocument, setOpenDocument] =
        useState(null);

    const [showMenu, setShowMenu] =
        useState(false);

    const [directoryHistory, setDirectoryHistory] =
        useState([]);


		//--------------------------------------------------------
		// Initial Directory
		//--------------------------------------------------------

		useEffect(
		    () =>
		    {
		        if(
		            !directories ||
		            directories.length === 0 ||
		            !id
		        )
		        {
		            return;
		        }

		        const directory =
		            directories.find(
		                (item) =>
		                    item.id === Number(id)
		            );

		        if(!directory)
		        {
		            return;
		        }

		        //------------------------------------------------
		        // Select directory to load its documents
		        //------------------------------------------------

		        if(
		            !selectedDirectory ||
		            selectedDirectory.id !== directory.id
		        )
		        {
		            selectDirectory(
		                directory
		            );
		        }

		        //------------------------------------------------
		        // Load immediate child directories
		        //------------------------------------------------

		        if(
		            !directory.loaded &&
		            !directory.expanded
		        )
		        {
		            expandDirectory(
		                directory
		            );
		        }
		    },
		    [
		        directories,
		        id
		    ]
		);


    //--------------------------------------------------------
    // Filter Documents
    //--------------------------------------------------------

    const filteredDocuments =
        documents.filter(
            (doc) =>
            {
                const title =
                    doc.title || "";

                return title
                    .toLowerCase()
                    .includes(
                        searchText.toLowerCase()
                    );
            }
        );


		//--------------------------------------------------------
		// Child Directories
		//--------------------------------------------------------

		const childDirectories =
		    selectedDirectory &&
		    selectedDirectory.children
		        ?
		        selectedDirectory.children
		        :
		        [];


	//--------------------------------------------------------
	// Select Directory
	//--------------------------------------------------------

	const handleDirectoryClick =
	    (directory) =>
	    {
	        if(selectedDirectory)
	        {
	            setDirectoryHistory(
	                (current) =>
	                    [
	                        ...current,
	                        selectedDirectory
	                    ]
	            );
	        }

	        setSearchText("");

	        //------------------------------------------------
	        // Select directory and load its documents
	        //------------------------------------------------

	        selectDirectory(
	            directory
	        );

	        //------------------------------------------------
	        // Load its child directories if required
	        //------------------------------------------------

	        if(
	            expandDirectory &&
	            !directory.loaded
	        )
	        {
	            expandDirectory(
	                directory
	            );
	        }
	    };

		//--------------------------------------------------------
		// Back Directory
		//--------------------------------------------------------

		const handleBackDirectory =
		    () =>
		    {
		        if(
		            directoryHistory.length === 0
		        )
		        {
		            return;
		        }

		        const previousDirectory =
		            directoryHistory[
		                directoryHistory.length - 1
		            ];

		        setDirectoryHistory(
		            (current) =>
		                current.slice(
		                    0,
		                    -1
		                )
		        );

		        setSearchText("");

		        selectDirectory(
		            previousDirectory
		        );
		    };

    //--------------------------------------------------------
    // Open File
    //--------------------------------------------------------

    const openFile =
        (doc) =>
        {
            const extension =
                (
                    doc.extension ||
                    ""
                )
                .toLowerCase();


            //------------------------------------------------
            // Forge Viewer
            //------------------------------------------------

            if(
                extension === "rvt" ||
                extension === "dwg" ||
                extension === "ifc" ||
                extension === "nwd"
            )
            {
                setViewerType(
                    "forge"
                );

                setSelectedDocument(
                    doc
                );

                setOpenDocument(
                    doc
                );

                return;
            }


            //------------------------------------------------
            // SharePoint Blob
            //------------------------------------------------

            functions.getBlobFromAjax(

                "/resolutionsoftwareplatform/" +
                "api/sharepoint/file/" +
                doc.sharePointId,

                function(blob)
                {
                    const url =
                        window.URL
                            .createObjectURL(
                                blob
                            );

                    setViewerType(
                        "blob"
                    );

                    setSelectedDocument(
                        doc
                    );

                    setOpenDocument(
                        doc
                    );

                    setOpenDocumentUrl(
                        url
                    );
                }

            );
        };


    //--------------------------------------------------------
    // Close Viewer
    //--------------------------------------------------------

    const closeViewer =
        () =>
        {
            if(openDocumentUrl)
            {
                window.URL.revokeObjectURL(
                    openDocumentUrl
                );
            }

            setViewerType(
                null
            );

            setOpenDocumentUrl(
                null
            );

            setOpenDocument(
                null
            );

            setSelectedDocument(
                null
            );
        };


    //--------------------------------------------------------
    // Normalise Forge URN
    //--------------------------------------------------------

    const normaliseUrn =
        (urn) =>
        {
            if(!urn)
            {
                return null;
            }

            let cleaned =
                urn.replace(
                    /^urn:/i,
                    ""
                );

            cleaned =
                cleaned.replace(
                    /\?.*$/,
                    ""
                );

            return cleaned;
        };


    //--------------------------------------------------------
    // Extension Label
    //--------------------------------------------------------

    const getExtension =
        (document) =>
        {
            if(!document.extension)
            {
                return "FILE";
            }

            return document.extension
                .toUpperCase();
        };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div className="mobile-documents-page">


            {/*------------------------------------------------
                Header
            ------------------------------------------------*/}

            <MobileHeader

                openMenu={
                    () =>
                        setShowMenu(true)
                }

                openSearch={
                    () =>
                    {
                        const input =
                            window.document
                                .getElementById(
                                    "mobile-documents-search"
                                );

                        if(input)
                        {
                            input.focus();
                        }
                    }
                }

            />


            {/*------------------------------------------------
                Page Heading
            ------------------------------------------------*/}

            <div className="mobile-documents-heading">

                <div className="mobile-documents-eyebrow">

                    DOCUMENT LIBRARY

                </div>


                <div className="mobile-documents-title-row">

                    {
                        directoryHistory.length > 0 &&
                        (
                            <button

                                className="mobile-documents-back"

                                type="button"

                                onClick={
                                    handleBackDirectory
                                }

                            >

                                ‹

                            </button>
                        )
                    }


                    <div className="mobile-documents-title">

                        {
                            selectedDirectory
                                ?
                                selectedDirectory.name
                                :
                                "Documents"
                        }

                    </div>

                </div>


                <div className="mobile-documents-subtitle">

                    {
                        childDirectories.length
                    }

                    {
                        childDirectories.length === 1
                            ?
                            " folder"
                            :
                            " folders"
                    }

                    <span>
                        {" · "}
                    </span>

                    {
                        documents.length
                    }

                    {
                        documents.length === 1
                            ?
                            " document"
                            :
                            " documents"
                    }

                </div>

            </div>


            {/*------------------------------------------------
                Search
            ------------------------------------------------*/}

            <div className="mobile-documents-search-container">

                <div className="mobile-documents-search">

                    <span className="mobile-documents-search-icon">

                        ⌕

                    </span>

                    <input

                        id="mobile-documents-search"

                        type="text"

                        value={
                            searchText
                        }

                        placeholder="Search this folder"

                        onChange={
                            (event) =>
                                setSearchText(
                                    event.target.value
                                )
                        }

                    />

                    {
                        searchText &&
                        (
                            <button

                                type="button"

                                className="mobile-documents-search-clear"

                                onClick={
                                    () =>
                                        setSearchText("")
                                }

                            >

                                ×

                            </button>
                        )
                    }

                </div>

            </div>


            {/*------------------------------------------------
                Browser
            ------------------------------------------------*/}

            <div className="mobile-documents-browser">


                {/*--------------------------------------------
                    Loading
                --------------------------------------------*/}

                {
                    loading &&
                    (
                        <div className="mobile-documents-loading">

                            Loading documents...

                        </div>
                    )
                }


                {/*--------------------------------------------
                    Folders
                --------------------------------------------*/}

                {
                    !loading &&
                    childDirectories.length > 0 &&
                    (
                        <div className="mobile-documents-section">

                            <div className="mobile-documents-section-title">

                                FOLDERS

                            </div>

                            {
                                childDirectories.map(
                                    (directory) =>
                                    (
                                        <button

                                            key={
                                                directory.id
                                            }

                                            type="button"

                                            className="mobile-documents-folder"

                                            onClick={
                                                () =>
                                                    handleDirectoryClick(
                                                        directory
                                                    )
                                            }

                                        >

                                            <div className="mobile-documents-folder-icon">

                                                <FontAwesomeFolder />

                                            </div>

                                            <div className="mobile-documents-folder-content">

                                                <div className="mobile-documents-folder-title">

                                                    {
                                                        directory.name
                                                    }

                                                </div>

                                                <div className="mobile-documents-folder-subtitle">

                                                    {
                                                        directory.documentCount != null
                                                            ?
                                                            (
                                                                directory.documentCount +
                                                                (
                                                                    directory.documentCount === 1
                                                                        ?
                                                                        " document"
                                                                        :
                                                                        " documents"
                                                                )
                                                            )
                                                            :
                                                            "Open folder"
                                                    }

                                                </div>

                                            </div>

                                            <div className="mobile-documents-folder-arrow">

                                                ›

                                            </div>

                                        </button>
                                    )
                                )
                            }

                        </div>
                    )
                }


                {/*--------------------------------------------
                    Documents
                --------------------------------------------*/}

                {
                    !loading &&
                    filteredDocuments.length > 0 &&
                    (
                        <div className="mobile-documents-section">

                            <div className="mobile-documents-section-title">

                                DOCUMENTS

                            </div>

                            {
                                filteredDocuments.map(
                                    (document) =>
                                    (
                                        <button

                                            key={
                                                document.id
                                            }

                                            type="button"

                                            className="mobile-documents-document"

                                            onClick={
                                                () =>
                                                    openFile(
                                                        document
                                                    )
                                            }

                                        >

                                            <div className="mobile-documents-document-icon">

                                                <div className="mobile-documents-extension">

                                                    {
                                                        getExtension(
                                                            document
                                                        )
                                                    }

                                                </div>

                                            </div>

                                            <div className="mobile-documents-document-content">

                                                <div className="mobile-documents-document-title">

                                                    {
                                                        document.title
                                                    }

                                                </div>

                                                <div className="mobile-documents-document-subtitle">

                                                    {
                                                        getExtension(
                                                            document
                                                        )
                                                    }

                                                    {" document"}

                                                </div>

                                            </div>

                                            <div className="mobile-documents-document-arrow">

                                                ›

                                            </div>

                                        </button>
                                    )
                                )
                            }

                        </div>
                    )
                }


                {/*--------------------------------------------
                    Empty
                --------------------------------------------*/}

                {
                    !loading &&
                    childDirectories.length === 0 &&
                    filteredDocuments.length === 0 &&
                    (
                        <div className="mobile-documents-empty">

                            <div className="mobile-documents-empty-icon">

                                📁

                            </div>

                            <div className="mobile-documents-empty-title">

                                Nothing here

                            </div>

                            <div className="mobile-documents-empty-text">

                                No documents or folders were found.

                            </div>

                        </div>
                    )
                }

            </div>


            {/*------------------------------------------------
                Blob Viewer
            ------------------------------------------------*/}

            {
                viewerType === "blob" &&
                openDocumentUrl &&
                (
                    <div className="mobile-documents-viewer">

                        <div className="mobile-documents-viewer-header">

                            <button
                                type="button"
                                onClick={
                                    closeViewer
                                }
                            >
                                ‹
                            </button>

                            <div>

                                {
                                    openDocument
                                        ?
                                        openDocument.title
                                        :
                                        "Document"
                                }

                            </div>

                        </div>


                        <div className="mobile-documents-viewer-content">

                            <iframe

                                src={
                                    openDocumentUrl
                                }

                                title={
                                    openDocument
                                        ?
                                        openDocument.title
                                        :
                                        "Document"
                                }

                            />

                        </div>

                    </div>
                )
            }


            {/*------------------------------------------------
                Forge Viewer
            ------------------------------------------------*/}

            {
                viewerType === "forge" &&
                openDocument &&
                (
                    <div className="mobile-documents-viewer">

                        <div className="mobile-documents-viewer-header">

                            <button
                                type="button"
                                onClick={
                                    closeViewer
                                }
                            >
                                ‹
                            </button>

                            <div>

                                {
                                    openDocument.title
                                }

                            </div>

                        </div>


                        <div className="mobile-documents-viewer-content">

                            <ForgeViewer

                                urn={
                                    normaliseUrn(
                                        openDocument.forgeUrn
                                    )
                                }

                                viewerLeft="0px"
                                viewerTop="0px"
                                viewerRight="0px"
                                viewerBottom="0px"

                            />

                        </div>

                    </div>
                )
            }

        </div>
    );

}


//--------------------------------------------------------
// Tiny Folder Icon
//--------------------------------------------------------

function FontAwesomeFolder()
{

    return (

        <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
        >

            <path

                fill="currentColor"

                d={
                    "M3 5.5C3 4.67 3.67 4 4.5 4H9" +
                    "l2 2h8.5c.83 0 1.5.67 1.5 1.5v10" +
                    "c0 .83-.67 1.5-1.5 1.5h-15" +
                    "C3.67 19 3 18.33 3 17.5v-12z"
                }

            />

        </svg>
    );

}